import React from "react";
import ClientHeader from "../../client-header/components/index";
import ClientFooter from "../../client-footer/components/index";

const ClientPrivacy = () => {
  return (
    <>
      <ClientHeader />
      <main className="overflow-hidden mt-2">
        
        {/* --- HERO SECTION --- */}
        <section className="homepad-about py-5" style={{ backgroundColor: "#083B5C" }}>
          <div className="container py-lg-5 text-center">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <h1 className="font-weight-bold montserrat text-white mb-3" style={{ fontSize: "3.5rem", lineHeight: "1.1" }}>
                  Privacy Policy
                </h1>
                <p className="text-white opacity-75 font-size-18 mb-0">
                  Last Updated: October 24, 2024
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* --- CONTENT SECTION --- */}
        <section className="py-5 my-4">
          <div className="container py-lg-4">
            <div className="row g-5">
              
              {/* Sticky Sidebar Navigation */}
              <div className="col-lg-4 d-none d-lg-block">
                <div className="position-sticky" style={{ top: "120px" }}>
                  <div className="card border-0 shadow-sm rounded-4 p-4" style={{ backgroundColor: "#f4f7f6" }}>
                    <h5 className="font-weight-bold text-primary mb-3">Table of Contents</h5>
                    <ul className="list-unstyled mb-0 font-size-15" style={{ lineHeight: "2.2" }}>
                      <li><a href="#introduction" className="text-muted text-decoration-none hover-success">1. Introduction</a></li>
                      <li><a href="#information" className="text-muted text-decoration-none">2. Information We Collect</a></li>
                      <li><a href="#usage" className="text-muted text-decoration-none">3. How We Use Information</a></li>
                      <li><a href="#sharing" className="text-muted text-decoration-none">4. Sharing Your Information</a></li>
                      <li><a href="#security" className="text-muted text-decoration-none">5. Data Security</a></li>
                      
                    </ul>
                  </div>
                </div>
              </div>

              {/* Main Content */}
              <div className="col-lg-8">
                <div className="privacy-content text-muted font-size-16 line-hight-3">
                  
                  <h3 id="introduction" className="font-weight-bold text-primary font-size-28 mb-3">1. Introduction</h3>
                  <p className="mb-4">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                  </p>
                  <p className="mb-5">
                    Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit.
                  </p>

                  <h3 id="information" className="font-weight-bold text-primary font-size-28 mb-3">2. Information We Collect</h3>
                  <p className="mb-4">
                    At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.
                  </p>
                  <ul className="mb-5" style={{ paddingLeft: "1.5rem" }}>
                    <li className="mb-2"><strong>Personal Data:</strong> Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
                    <li className="mb-2"><strong>Usage Data:</strong> Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</li>
                    <li className="mb-2"><strong>Cookies:</strong> Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.</li>
                  </ul>

                  <h3 id="usage" className="font-weight-bold text-primary font-size-28 mb-3">3. How We Use Information</h3>
                  <p className="mb-4">
                    Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe eveniet.
                  </p>
                  
                  <h3 id="sharing" className="font-weight-bold text-primary font-size-28 mb-3">4. Sharing Your Information</h3>
                  <p className="mb-4">
                    Itaque earum rerum hic tenetur a sapiente delectus, ut aut reiciendis voluptatibus maiores alias consequatur aut perferendis doloribus asperiores repellat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  </p>

                  <h3 id="security" className="font-weight-bold text-primary font-size-28 mb-3">5. Data Security</h3>
                  <p className="mb-4">
                    Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit.
                  </p>

                 

                </div>
              </div>

            </div>
          </div>
        </section>
      </main>
      <ClientFooter />
    </>
  );
};

export default ClientPrivacy;